export default function bestRatedSongs() {
  const data = $("#best-rated-songs").data("bestRates");
  return {
    type: "bar",
    canvasID: "best-rated-songs",
    options: {
      indexAxis: "y",
      layout: {
        padding: 20,
      },
      interaction: {
        mode: "nearest",
        intersect: false,
      },
      scales: {
        x: { grid: { display: false } },
      },
      plugins: {
        legend: {
          display: false,
          position: "right",
        },
        title: {
          display: true,
          text: "Musicas melhor avaliadas",
        },
      },
    },
    data: {
      labels: Object.keys(data),
      datasets: [
        {
          label: "Avaliações positivas",
          data: Object.values(data),
          backgroundColor: [
            "rgba(68, 121, 9, 0.2)",
            "rgba(177, 31, 89, 0.2)",
            "rgba(107, 180, 99, 0.2)",
            "rgba(123, 44, 89, 0.2)",
            "rgba(21, 122, 195, 0.2)",
          ],
          borderColor: [
            "rgba(68, 121, 9, 1)",
            "rgba(177, 31, 89, 1)",
            "rgba(107, 180, 99, 1)",
            "rgba(123, 44, 89, 1)",
            "rgba(21, 122, 195, 1)",
          ],
          borderWidth: 1,
        },
      ],
    },
  };
}
